export const PageNotFound = () => {
    return (
        <div className="pageNotFound">
            <h1>404</h1>
            <h2>Страница не найдена</h2>
        </div>
    )
}